import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export enum TaskAssignmentState {
  offered = 'offered',
  accepted = 'accepted',
  declined = 'declined',
}

export default class TaskAssignmentModel extends Model {
  @attr('boolean') viaRule!: boolean;

  @attr('string') taskId?: string;
  @attr('string') userId?: string;

  @attr('string') state!: TaskAssignmentState;
  @attr('number') position!: number;
  @attr('string') assigneeName?: string;
  @attr('string') startedAt?: string;
  @attr('string') finishedAt?: string;
  @attr('number') durationMinutes?: number;

  @cached
  get isOffered(): boolean {
    return this.state === TaskAssignmentState.offered;
  }

  @cached
  get isAccepted(): boolean {
    return this.state === TaskAssignmentState.accepted;
  }

  @cached
  get isDeclined(): boolean {
    return this.state === TaskAssignmentState.declined;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'task-assignment': TaskAssignmentModel;
  }
}
